import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'digi-table-inline-edit',
  templateUrl: './table-inline-edit.component.html',
  styleUrl: './table-inline-edit.component.scss'
})
export class TableInlineEditComponent {
  @Input() fields: any[] = [];
  @Input() data: any[] = [];
  @Output() valueChange = new EventEmitter<any[]>();
  @Input() control!: FormControl;           // FormControl để quản lý giá trị và trạng thái
  @Input() errorMessage: string = '';      // Thông báo lỗi nếu có
  @ViewChild(MatTable) table!: MatTable<any>; // Tham chiếu đến table
  dataSource = new MatTableDataSource<any>([]); // Dữ liệu cho bảng
  formArray!: FormArray;
  editMode: boolean[] = [];
  fullData: any[] = [];
  displayedColumns: string[] = [];

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    console.log(this.data);
    
    this.formArray = this.fb.array([]);

    this.displayedColumns = ['stt', ...this.fields.map(f => f.key), 'actions'];
    if (this.data && this.data.length) {
      this.data.forEach(item => this.addRow(item));
    } 
    this.updateTableData(); // Khởi tạo dữ liệu bảng
  }

  get rows(): FormArray<FormGroup> {
    return this.formArray as FormArray<FormGroup>;
  }

  getRow(index: number): FormGroup {
    return this.rows.at(index) as FormGroup;
  }

  createGroup(data: any = {}): FormGroup {
    const group: any = {};
  
    this.fields.forEach(field => {
      const validators = [];
  
      if (field.required) validators.push(Validators.required);
      if (field.min !== undefined) validators.push(Validators.min(field.min));
      if (field.max !== undefined) validators.push(Validators.max(field.max));
  
      let value = data[field.key] || '';
  
      if (field.type === 'date' && value) {
        const dateObj = new Date(value);
        if (!isNaN(dateObj.getTime())) {
          // 👉 Chuyển thành chuỗi yyyy-MM-dd để binding với input date
          value = this.formatDate(dateObj);
        } else {
          value = ''; // Giá trị không hợp lệ
        }
      }
  
      group[field.key] = new FormControl(value, validators);
    });
  
    return new FormGroup(group);
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  addRow(item: any = {}): void {
    const group = this.createGroup(item);
    this.rows.push(group);
    this.fullData.push({ ...item }); // Lưu giữ tất cả dữ liệu gốc
    this.editMode.push(false);
    this.updateTableData(); // Cập nhật table
    this.emitChange();
    this.control.setValue(this.getFullRows());
  }

  removeRow(index: number): void {
  
    this.rows.removeAt(index);
    this.editMode.splice(index, 1);
    this.fullData.splice(index, 1); // Xóa cả bản đầy đủ
    this.updateTableData();
    this.emitChange();
    this.control.setValue(this.getFullRows());
    
  }

  onEditRow(index: number): void {
    this.editMode[index] = true;
  }

  // onSaveRow(index: number): void {
  //   const row = this.getRow(index);
  //   if (row.valid) {
  //     this.editMode[index] = false;
  //     this.updateTableData();
  //     this.emitChange();
  //     this.control.setValue(this.rows.value);
  //   } else {
  //     row.markAllAsTouched();
  //   }
  // }
  onSaveRow(index: number): void {
    const row = this.getRow(index);
    if (row.valid) {
      this.editMode[index] = false;
  
      // 👉 Cập nhật lại `fullData` với dữ liệu vừa sửa
      this.fullData[index] = {
        ...this.fullData[index],   // dữ liệu gốc (ẩn)
        ...row.value               // dữ liệu form đang sửa
      };
  
      this.emitChange();
      this.control.setValue(this.getFullRows());
    } else {
      row.markAllAsTouched();
    }
  }

  getFullRows(): any[] {
    return this.fullData.map((item, index) => ({
      ...item,
      ...this.rows.at(index).value // cập nhật dữ liệu vừa nhập
    }));
  }

  onCancelEdit(index: number): void {
    this.editMode[index] = false;
  }

  emitChange(): void {
    this.valueChange.emit(this.getFullRows());
  }
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/[^0-9]/g, ''); // Loại bỏ ký tự không phải số
    input.value = numericValue; // Cập nhật lại giá trị
  }
  updateTableData(): void {
    this.dataSource.data = this.rows.controls;
    if (this.table) {
      this.table.renderRows(); // Trigger cập nhật bảng
    }
  }
}
